import { TFunction } from 'i18next';
import RadioButtonGroup, {
  RadioButtonWrapViews,
} from '@lib/components/RadioButtonGroup/RadioButtonGroup';
import Input from '@lib/components/Input/Input';
import RadioButtonAsChipColor from '@lib/components/RadioButtonAsChipColor/RadioButtonAsChipColor';
import { FieldItem } from '@lib/interfaces/form';
import FieldNames from '@lib/enums/fieldNames/interventionCategoryFieldNames';
import { InputTypes } from '@lib/components/Input/enums';
import {
  getFieldValidation,
  getOptionValidation,
} from '@lib/utils/validationUtils';
import getColorOptions from '@lib/components/Chip/utils/colorEnum';

type IndustryFormFieldsArgs = {
  t: TFunction<'translation', undefined>;
};

export default function getCategoryFormFields({
  t,
}: IndustryFormFieldsArgs): FieldItem[] {
  return [
    {
      name: FieldNames.Name,
      label: t('category-name'),
      element: Input,
      validation: getFieldValidation({ required: true, t }),
      componentProps: {
        autoFocus: true,
      },
    },
    {
      name: FieldNames.Description,
      label: t('description'),
      element: Input,
      componentProps: {
        type: InputTypes.textarea,
      },
      validation: getFieldValidation({ t }),
    },
    {
      name: FieldNames.Color,
      label: t('label-color'),
      element: RadioButtonGroup,
      validation: getOptionValidation({ required: true, t }),
      componentProps: {
        options: getColorOptions({ t }),
        RadioButtonComponent: RadioButtonAsChipColor,
        wrapView: RadioButtonWrapViews.colors,
      },
    },
  ];
}
